module.exports = __webpack_public_path__ + "img/finance_thumbnail-400x300.9ffe05ce.jpg";